import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-update-sequence-video-popup',
  templateUrl: './update-sequence-video-popup.component.html',
  styleUrls: ['./update-sequence-video-popup.component.scss']
})
export class UpdateSequenceVideoPopupComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<UpdateSequenceVideoPopupComponent>) { }

  ngOnInit(): void {
  }

  closeDialog() {
    this.dialogRef.close(false);
  }
}
